import * as Sentry from "@sentry/react"

const SENSITIVE_GRAPHQL_OPERATION_NAMES = [
	"GetDataSourceLoginPassword",
	"getDataSourceLoginPassword",
]
const REDACTED_PASSWORD_PAYLOAD = "[REDACTED - contains password]"

const containsSensitiveGraphQLOperation = (value: unknown): boolean => {
	if (typeof value === "string") {
		return SENSITIVE_GRAPHQL_OPERATION_NAMES.some((operationName) =>
			value.includes(operationName)
		)
	}

	if (value == null) return false

	try {
		return containsSensitiveGraphQLOperation(JSON.stringify(value))
	} catch {
		return false
	}
}

const redactNetworkPayload = (data: Record<string, unknown>) => ({
	...data,
	body: data.body == null ? data.body : REDACTED_PASSWORD_PAYLOAD,
	request: data.request == null ? data.request : REDACTED_PASSWORD_PAYLOAD,
	response: data.response == null ? data.response : REDACTED_PASSWORD_PAYLOAD,
})

export const initSentry = () => {
	Sentry.init({
		dsn:
			process.env.SENTRY_DSN ||
			"https://03a85b99ff106e555a2de32069e4e7f0@o4509149464494080.ingest.us.sentry.io/4509149465542656",
		environment: process.env.REACT_APP_IS_PROD
			? "production"
			: "non-production",
		integrations: [
			// パフォーマンス計測（Performance Monitoring）を有効にするインテグレーション。
			// ⇨のやつ?: https://sentry.io/organizations/souhl-inc/insights/frontend/?project=4509149465542656&statsPeriod=14d
			Sentry.browserTracingIntegration(),

			Sentry.replayIntegration({
				// 強気に input 以外はマスクをしないようにしている
				// TODO: 要検討
				maskAllText: false,
				maskAllInputs: true,
				blockAllMedia: false,

				// Network tab の X-Request-Id をキャプチャ (Replay でみれる)
				// ref: https://docs.sentry.io/platforms/javascript/session-replay/configuration/#privacy-configuration
				networkDetailAllowUrls: [window.location.origin],
				networkCaptureBodies: false,
				networkRequestHeaders: ["X-Request-Id"],
			}),
		],
		beforeSend(event) {
			if (event.breadcrumbs) {
				event.breadcrumbs = event.breadcrumbs.map((breadcrumb) => {
					const isNetworkBreadcrumb =
						breadcrumb.category === "xhr" || breadcrumb.category === "fetch"
					if (
						!isNetworkBreadcrumb ||
						!containsSensitiveGraphQLOperation(breadcrumb.data)
					) {
						return breadcrumb
					}

					return {
						...breadcrumb,
						data: redactNetworkPayload(breadcrumb.data ?? {}),
					}
				})
			}

			if (containsSensitiveGraphQLOperation(event.request?.data)) {
				event.request = {
					...event.request,
					data: REDACTED_PASSWORD_PAYLOAD,
				}
			}

			return event
		},

		// Session Replay - エラー時のみ記録
		replaysSessionSampleRate: 0, // 通常セッションは記録しない
		replaysOnErrorSampleRate: 1.0, // エラー発生時は100%記録

		// Tracing - リクエストのパフォーマンス計測 (現状あまり活用していない。BE の方も Trace 出すなら、BE のどんな span (エラー) がでているか sentry で一目でわかるというメリットがあるかも...)
		// browserTracingIntegration の rate でもある。
		// span は枯渇しがちなので、減らしておく。
		// TODO: 調整
		tracesSampleRate: 0.1,

		// フロントエンドがAPIリクエストを送るとき、Sentryは sentry-trace ヘッダーを自動付与する
		// これらのURLへのリクエストにのみ sentry-trace ヘッダーが付く。
		// tracePropagationTargets: process.env.SENTRY_TRACE_PROPAGATION_TARGETS
		// 	? process.env.SENTRY_TRACE_PROPAGATION_TARGETS.split(",")
		// 	: [
		// 			"refundhub.jp",
		// 			/^https:\/\/refundhub\.jp/,
		//       // TODO: backend
		// 		],
	})
}
